import { LabelId, UserCommunication } from '@this+that/models';

export const canArchiveUserCommunication = (
  userCommunication: UserCommunication,
): boolean => {
  const labelIds = userCommunication.labelIds || [];

  if (labelIds.length === 1 && labelIds[0] === LabelId.SENT) {
    return false;
  }

  return true;
};
